import React from "react";
import { Button, Checkbox, Popover, Space, theme } from "antd";
import { DownOutlined } from "@ant-design/icons";

// Chip desplegable de filtro. Muestra "Todos" cuando todas las opciones están
// seleccionadas, o el número de opciones activas en otro caso.
export default function FiltroChip({ titulo, opciones, valor, onChange }) {
  const { token } = theme.useToken();
  const todos = opciones.map((o) => o.value);
  const resumen = valor.length === todos.length ? "Todos" : String(valor.length);

  const contenido = (
    <div style={{ minWidth: 240 }}>
      <Checkbox.Group
        value={valor}
        onChange={onChange}
        options={opciones}
        style={{ display: "flex", flexDirection: "column", gap: 10 }}
      />
      <Space style={{ marginTop: 12 }}>
        <Button type="link" size="small" onClick={() => onChange(todos)}>
          Todos
        </Button>
        <Button type="link" size="small" onClick={() => onChange([])}>
          Ninguno
        </Button>
      </Space>
    </div>
  );

  return (
    <Popover trigger="click" placement="bottomLeft" arrow={false} content={contenido}>
      <Button
        shape="round"
        aria-label={`Filtrar por ${titulo}: ${resumen}`}
        style={{ height: 44, paddingInline: 16, display: "inline-flex", alignItems: "center", gap: 8 }}
      >
        <span>{titulo}</span>
        <span style={{ color: token.colorPrimary, fontWeight: 600 }}>{resumen}</span>
        <DownOutlined style={{ fontSize: 11 }} aria-hidden="true" />
      </Button>
    </Popover>
  );
}
